import PaginatedContent from "./PaginatedContent";

export const paginatedContent = {
  init: () => {
    const paginations = document.querySelectorAll(".sd-pagination");
    [...paginations].forEach((pagination) => new PaginatedContent(pagination,null));
  }
};

export default paginatedContent;
